
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tomorrow-central",
      function () {
        return require("private-next-pages/tomorrow-central.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tomorrow-central"])
      });
    }
  